package one.healthium.onboarding.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.TextStyle

@Serializable
data class HighlightList(
    @SerialName("emoji_height") val emojiHeight: Int? = null,
    @SerialName("text_label") val textLabel: TextStyle? = null,
    @SerialName("items") val items: List<HighlightItem> = emptyList(),
)